module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_1_2ac7b261.98e4afbf.woff2";